import { Link } from 'react-router-dom';
import { useSesion } from '../sesion';
import { FilaDeUsuario } from './FilaDeUsuario';
import { FormularioDeAlta } from './FormularioDeAlta';
import { useUsuarios } from './consultas';
import { mensajeDeUsuarios } from './mensajes';

/**
 * ABM de las personas que usan el sistema (KAN-143). Ruta `/admin/usuarios`,
 * dentro de `RequiereRol="ADMIN"`.
 *
 * # LOS INACTIVOS SE MUESTRAN, NO SE ESCONDEN
 *
 * El backend devuelve activos e inactivos y la tabla los muestra a todos, con una
 * columna que dice cuál es cuál. Filtrarlos "para limpiar la vista" tendría un
 * efecto concreto: **el botón de reactivar dejaría de existir en la pantalla**, y
 * volver a habilitar a alguien pasaría a ser un misterio. La baja acá es lógica —
 * la fila queda porque hay que poder atribuir un comprobante a quien lo pidió— y
 * la pantalla tiene que reflejar eso, no simular un borrado que no ocurrió.
 *
 * # LO QUE ESTA PANTALLA NO ES
 *
 * No es control de acceso. Lo es el backend, que exige `ROLE_ADMIN` en
 * `/api/v1/admin/**` y aplica por su cuenta las dos reglas de la fila propia. Acá
 * se anticipan para no ofrecer botones cuyo único destino posible es un error —
 * pero el `409` se maneja igual, porque esta lista puede estar vieja.
 */
export function PantallaDeUsuarios() {
  const { sesion } = useSesion();
  const lista = useUsuarios();

  if (!sesion) {
    return null; // Inalcanzable: cuelga de RutaProtegida. Es para el tipo.
  }

  return (
    <main>
      <p>
        <Link to="/admin">Administración</Link>
      </p>
      <h1>Usuarios</h1>
      <p>
        Las personas que entran con email y contraseña. Los sistemas conectados —las aplicaciones
        que emiten con una API key— se administran aparte.
      </p>

      {lista.isPending ? <p role="status">Cargando usuarios…</p> : null}

      {lista.isError ? (
        <p role="alert" className="error">
          {mensajeDeUsuarios(lista.error, 'modificar')}
        </p>
      ) : null}

      {lista.data ? (
        <table>
          <caption className="nota">
            Se listan los activos y los dados de baja. La baja es lógica: la fila queda para poder
            saber quién pidió cada comprobante, y por eso a alguien dado de baja se lo puede
            reactivar.
          </caption>
          <thead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Email</th>
              <th scope="col">Rol</th>
              <th scope="col">Estado</th>
              <th scope="col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {lista.data.map((usuario) => (
              <FilaDeUsuario key={usuario.id} usuario={usuario} yoId={sesion.usuarioId} />
            ))}
          </tbody>
        </table>
      ) : null}

      <FormularioDeAlta />
    </main>
  );
}
